import styled from 'styled-components';
import Colors from '../../constants/color';

export const ItemList: any = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 15px 0px 15px 0px;
  height: 50px;
`;
export const Item: any = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 50px;
  width: 50%;
`;
export const Avatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  background-image: linear-gradient(to bottom, #00de7f, #00cebc, #00b7f0, #0098ff, #276fec);
  border-radius: 100%;
`;
export const Sigla = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 46px;
  width: 46px;
  color: white;
  font-size: 10px;
  background-color: ${Colors.grey1};
  border-radius: 100%;
`;
export const Small: any = styled.small`
  font-size: 14px;
  margin-left: 8px;
  color: ${(props: any) => (props.color ? props.color : 'white')};
  font-family: 'Graphik-Regular';
`;
